import classNames from "classnames";
import React, { forwardRef, Ref } from "react";

import styles from "./index.module.scss";

type Props = {
  padding?: string;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  id?: string;
  as?: "div" | "li" | "section";
} & React.HTMLAttributes<HTMLElement>;

function Card(
  { className, style = {}, padding, as: Component = "section", ...restProps }: Props,
  ref: Ref<HTMLElement>
) {
  return React.createElement(Component, {
    ref,
    style: {
      ...style,
      padding,
    },
    className: classNames(styles.card, "talaera-card", className),
    ...restProps,
  });
}

export default forwardRef(Card);
